import { EditorView } from "@codemirror/view";

export const trackChangesTheme = EditorView.baseTheme({
    ".ol-cm-change-i, .ol-cm-change-highlight-i, .ol-cm-change-focus-i": {
        backgroundColor: "rgba(44, 142, 48, 0.30)",
    },
    "&light .ol-cm-change-c, &light .ol-cm-change-highlight-c, &light .ol-cm-change-focus-c": {
        backgroundColor: "rgba(243, 177, 17, 0.30)",
    },
    "&dark .ol-cm-change-c, &dark .ol-cm-change-highlight-c, &dark .ol-cm-change-focus-c": {
        backgroundColor: "rgba(194, 93, 11, 0.15)",
    },
    ".ol-cm-change-focus .ol-cm-change": {
        backgroundColor: "transparent",
    },
    ".ol-cm-change": {
        padding: "var(--half-leading, 0) 0",
    },
    ".ol-cm-change-highlight": {
        padding: "var(--half-leading, 0) 0",
    },
    ".ol-cm-change-focus": {
        padding: "var(--half-leading, 0) 0",
    },
    "&light .ol-cm-change-d": {
        borderLeft: "2px dotted #c5060b",
        marginLeft: "-1px",
    },
    "&dark .ol-cm-change-d": {
        borderLeft: "2px dotted #c5060b",
        marginLeft: "-1px",
    },
    "&light .ol-cm-change-d-highlight": {
        borderLeft: "3px solid #c5060b",
        marginLeft: "-2px",
    },
    "&dark .ol-cm-change-d-highlight": {
        borderLeft: "3px solid #c5060b",
        marginLeft: "-2px",
    },
});
